import {
  LIST_PACKAGES,
  CREATE_PACKAGE,
  UPDATE_PACKAGE,
} from '@/data/actions/modules/clinical';

export default [
  {
    path: '/clinical/packages',
    component: () => import(/* webpackChunkName: "places" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: LIST_PACKAGES,
    },
  },
  {
    path: '/clinical/packages/create',
    component: () => import(/* webpackChunkName: "places" */ './components/Form.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: CREATE_PACKAGE,
    },
  },
  {
    path: '/clinical/packages/:id/edit',
    component: () => import(/* webpackChunkName: "places" */ './components/Form.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: UPDATE_PACKAGE,
    },
  },
];
